import { useQuery } from "react-query";
import { modelTaxYearResult } from "../api/user/modelTaxYearResult";
import { TRANSACTIONS_CACHE_KEY } from "./transactionsStore";

export const useQueryModelTaxResult = ({
  financialYearValue,
  enabled = true,
}: {
  financialYearValue: string | undefined;
  enabled?: boolean;
}) =>
  useQuery(
    [TRANSACTIONS_CACHE_KEY, financialYearValue, "modelTaxResult"],
    () => modelTaxYearResult({ financialYearValue: financialYearValue! }),
    { enabled: !!financialYearValue && enabled }
  );
